import http from "@/shared/services/http";

export const listDebtPartner= (params: any) =>  http.get(`v1/debt-employees`,  { params });
export const allDebtPartner= (params: any) =>  http.get(`v1/debt-employees/all`,  { params });
export const receiptPartner = (data: any) =>  http.post(`v1/revenue-expenditures/partner`, data);